module.exports = __webpack_public_path__ + "media/home1-left.ccf53091.mp4";